






import {Component, Prop} from 'vue-property-decorator'

import Avatar from './proxy/Avatar.vue'
import Button from './Button.vue'
import Btn from './proxy/Btn.vue'

@Component({
  components: {
    Btn,
    Avatar,
    Button,
  },
})
export default class FloatingActionButton extends Button {
}
